import type { FocusEvent } from 'react';

/**
 * Some Pulse UI fields (SelectField, RadioGroupEnhanced, Checkbox, SelectCountryPhone) don't expose
 * `onBlur`. Put this on a wrapper so react-hook-form still marks the field as touched once focus
 * leaves it, not when it moves between the field's own parts (e.g. from one radio to the next).
 */
export const blurWhenFocusLeaves =
  (onBlur: () => void) =>
  ({ currentTarget, relatedTarget }: FocusEvent<HTMLElement>) => {
    if (!currentTarget.contains(relatedTarget as Node | null)) {
      onBlur();
    }
  };
